import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { CommercialOfferActions, GENERATE_COMMERCIAL_OFFER } from 'models/CommercialOffer';
import { useGenerateCommercialOfferMutation, useRequestPriceConfirmationMutation } from 'api';

export const useOfferActions = (
  id: string,
  setOfferToReject: (id: string | undefined) => void,
  setOfferToNegotiate: (id: string | undefined) => void,
  handleSuccess: (message: string) => void
) => {
  const navigate = useNavigate();
  const [generateCommercialOffer] = useGenerateCommercialOfferMutation();
  const [requestPrice] = useRequestPriceConfirmationMutation();

  const handleAction = useCallback(
    async (action: string, offerId: string, uuid: string) => {
      const sendOfferUrl = ADMIN_ROUTES.deals.sendCommercialOffers
        .replace(':id', id as string)
        .replace(':offerId', offerId);

      switch (action) {
        case GENERATE_COMMERCIAL_OFFER:
          generateCommercialOffer({ commercialOfferId: offerId });
          handleSuccess(`Generating commercial offer for offer with ID: ${uuid || ''}`);
          break;
        case CommercialOfferActions.NEGOTIATE.value:
          setOfferToNegotiate(offerId);
          break;
        case CommercialOfferActions.REQUEST_PRICE_CONFIRMATION.value:
          requestPrice({ commercialOfferId: offerId });
          handleSuccess(`Requesting price confirmation for offer with ID: ${uuid || ''}`);
          break;
        case CommercialOfferActions.SEND_PRE_INVOICE.value:
          navigate(sendOfferUrl + `?action=${CommercialOfferActions.SEND_PRE_INVOICE.value}`);
          break;
        case CommercialOfferActions.SEND_ORDER_CONFIRMATION.value:
          navigate(sendOfferUrl + `?action=${CommercialOfferActions.SEND_ORDER_CONFIRMATION.value}`);
          break;
        case CommercialOfferActions.SEND_COMMERCIAL_OFFER.value:
          navigate(sendOfferUrl + `?action=${CommercialOfferActions.SEND_COMMERCIAL_OFFER.value}`);
          break;
        case CommercialOfferActions.REJECT.value:
          setOfferToReject(offerId);
          break;
        default:
          handleSuccess(`Performing ${action} on offer with ID: ${uuid || ''}`);
      }
    },
    [id, navigate, setOfferToReject, setOfferToNegotiate, handleSuccess, generateCommercialOffer, requestPrice]
  );

  return {
    handleAction,
  };
};
